import { ok } from '@nanovnaweb/shared';
import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
export function createModeStore(_deps) {
    const store = createStore()(() => ({ mode: 'idle' }));
    const actions = {
        async setMode(mode) {
            // IoApi.setMode will land in Plan #8+. For now, we track intent
            // locally; hardware-level mode exclusion is enforced by the
            // driver when setSweep / setSigGen are called.
            store.setState({ mode });
            return ok(undefined);
        },
    };
    return { store, actions };
}
export function useModeStore(store, selector) {
    return useZustandStore(store, selector);
}
//# sourceMappingURL=mode-store.js.map